export default __webpack_public_path__ + "static/media/membre_kheiredin.1e3270a4.jpg";